import React from 'react';  
import { Button } from "@fluentui/react-components";  
import "./styles.scss";  
  
export interface ButtonOption {  
    label: string;  
    value: any;  
    disabled?: boolean;  
}  
  
interface ButtonGroupProps {  
    options: ButtonOption[];  
    value?: any;  
    onChange: (value: any) => void;  
    multiple?: boolean;  
    name: string;  
    required?: boolean;  
    className?: string;  
}  
  
const ButtonGroup: React.FC<ButtonGroupProps> = ({  
    options,  
    multiple = false,  
    value,  
    onChange,  
    name,  
    required = false,  
    className  
}) => {  
    const defaultValue = multiple ? [] : '';  
    const currentValue = value ?? defaultValue;  
  
    const isSelected = (optionValue: any) => {  
        if (multiple) {  
            return (currentValue as any[])?.includes(optionValue);  
        }  
        return currentValue === optionValue;  
    };  
  
    const handleChange = (optionValue: any) => {  
        if (multiple) {  
            const values = (currentValue as any[]) || [];  
            const isCurrentlySelected = values.includes(optionValue);  
            if (required && isCurrentlySelected && values.length === 1) {  
                return;  
            }  
            const newValues = isCurrentlySelected  
                ? values.filter(v => v !== optionValue)  
                : [...values, optionValue];  
            onChange(newValues);  
        } else {  
            onChange(optionValue);  
        }  
    };  
  
    const hasSelection = multiple  
        ? (currentValue as any[])?.length > 0  
        : currentValue !== '' && currentValue !== undefined;  
  
    return (  
        <div className={"emc-button-group " + className}>  
            {options.map(({label, value: optionValue, disabled}) => (  
                <React.Fragment key={optionValue}>  
                    <Button  
                        className={isSelected(optionValue) ? 'selected' : ''}  
                        appearance="secondary"  
                        onClick={() => !disabled && handleChange(optionValue)}  
                        disabled={!!disabled}
                    >  
                        {label}  
                    </Button>  
                    <input  
                        type={multiple ? "checkbox" : "radio"}  
                        name={name}  
                        required={multiple ? false : required}  
                        value={optionValue}  
                        checked={isSelected(optionValue)}  
                        onChange={() => handleChange(optionValue)}  
                        className="hidden-input"  
                        tabIndex={-1}  
                        disabled={!!disabled} // <-- И тут!  
                    />  
                </React.Fragment>  
            ))}  
            {multiple && required && (  
                <input  
                    type="checkbox"  
                    required={required}  
                    checked={hasSelection}  
                    className="hidden-input"  
                    tabIndex={-1}  
                    onChange={() => {}}  
                />  
            )}  
        </div>  
    );  
};  
export default ButtonGroup;  